














import { Component, Vue } from "vue-property-decorator";
import TicketForm from "@/components/sale/forms/TicketForm.vue";

@Component({
  components: { TicketForm },
})
export default class extends Vue {}
